import { __postAjaxClient } from "utils/misc/fetchClient";
import { ILiteRouterApiResponse } from "models/ILiteRouterApiResponse";
import { EnumScreenNames } from "../../../enums/EnumScreenNames";
import { ISeoPage } from "../../../libs/seo-widget/types/types";
import { IPostData, IPostsApiResponse } from "models/post";
import { ICategoryLiteAsset } from "models/Assets/ICategoryAsset";
import {IJobPosterPostView, IJobSeekerPostView} from "models/jobPostView";
import {iPostListingData} from "../../../screens/PostView/_private/Api/types";

const parseRequest = (data: any): ISeoPage => {
  let output: any;
  output = {
    ...data,
    is410: data.status === 410,
    is404: data.status === 404,
    is302: data.redirectStatusCode === 302,
    is301: data.redirectStatusCode === 301,
    redirectTo: data.redirectTo || null,
  };
  delete output.redirectStatusCode;
  delete output.status;
  delete output.name;
  delete output.code;
  delete output.type;
  return output;
};

export const fetchSeoClientSide = async (
  locale: string,
  screenKey: EnumScreenNames,
  payload: {
    queryString?: any;
    routerApiResponse?: ILiteRouterApiResponse;
    postsApiResponse?: any;
    postDetails?: IPostData|IJobPosterPostView|IJobSeekerPostView | iPostListingData;
    category?: ICategoryLiteAsset;
    subCategory?: ICategoryLiteAsset;
  },
  abortController?: any
): Promise<ISeoPage | null> => {
  window.dispatchEvent(new Event("seoLoading"));

  let url = `/seo-widget-internal?locale=${locale}`;
  return __postAjaxClient(url, { screenKey, payload }, abortController)
    .then(parseRequest)
    .finally(() => {
      window.dispatchEvent(new Event("seoLoadingFinish"));
    });
};
